import * as Business                from '../business';
import * as ENV                     from '../util/env';
import * as User                    from '../user';
import { connect }                  from 'react-redux';
import { HasFeature }               from '../components/feature_available';
import { Link }                     from 'framework7-react';
import classnames                   from 'classnames';
import NotificationBadge            from '../components/notification_badge';
import React                        from 'react';

import { Send as CampaignsIcon }    from 'react-feather';
import { Inbox as ContactsIcon }    from 'react-feather';
import { FileText as ReportsIcon }  from 'react-feather';
import { Settings as SettingsIcon } from 'react-feather';
import { Users as TeamIcon }        from 'react-feather';
import { User as UserIcon }         from 'react-feather';


export default connect(
  (state, { businessID }) => ({
    contactsBadgeCount:     User.getContactsBadgeCount(state, businessID),
    settingsBadgeCount:     User.getSettingsBadgeCount(state, businessID),
    isHostedNumberComplete: Business.isHostedNumberComplete(state, businessID),
    isManager:              User.isManager(state, businessID)
  })
)(LocationLinks);


function LocationLinks({ businessID, tab, closeMenu, contactsBadgeCount, settingsBadgeCount, isManager, isHostedNumberComplete }) {
  const showPreferences = isManager || !isManager && isHostedNumberComplete && ENV.isWeb();

  function getURL({ path }) {
    return `/${businessID}${path}`;
  }

  return (
    <div className="location-links">
      <Tab
        icon={<ContactsIcon/>}
        badgeCount={contactsBadgeCount}
        label="Inbox"
        active={tab === 'inbox'}
        href={getURL({ path: '/inbox' })}
        closeMenu={closeMenu}
      />
      <Tab
        icon={<UserIcon/>}
        label="Contacts"
        active={tab === 'contacts'}
        href={getURL({ path: '/contacts' })}
        closeMenu={closeMenu}
      />
      <HasFeature businessID={businessID} feature="campaigns">
        <Tab
          icon={<CampaignsIcon/>}
          label="Campaigns"
          active={tab === 'campaigns'}
          href={getURL({ path: '/campaigns' })}
          closeMenu={closeMenu}
        />
      </HasFeature>
      <Tab
        icon={<TeamIcon/>}
        label="Team"
        active={tab === 'team-chat'}
        href={getURL({ path: '/team-chat' })}
        closeMenu={closeMenu}
      />
      <Tab
        icon={<ReportsIcon/>}
        label="Reports"
        active={tab === 'metrics'}
        href={getURL({ path: '/metrics' })}
        closeMenu={closeMenu}
      />
      {showPreferences && (
        <Tab
          icon={<SettingsIcon/>}
          badgeCount={settingsBadgeCount}
          label="Preferences"
          active={tab === 'settings'}
          href={getURL({ path: '/settings' })}
          closeMenu={closeMenu}
        />
      )}
    </div>
  );
}

function Tab({ icon, label, active, href, badgeCount, closeMenu }) {
  const className = classnames('tab-link', { 'tab-link-active': active });
  return (
    <Link className={className} href={href} role="tab" onClick={closeMenu}>
      <div className="icon-and-label">
        {typeof icon === 'string' && <i className={`icons8 icons8-${icon}`}/>}
        {typeof icon === 'object' && icon}
        <span className="tabbar-label">{label}</span>
      </div>
      <NotificationBadge className="badge-count" color="red" count={badgeCount}/>
    </Link>
  );
}
